import { t } from "@/i18n-js/instance";
import type { Event } from "@circle-react/types";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { useDownloadCSV } from "./hooks/useDownloadCSV";

interface DownloadCSVButtonProps {
  event: Event;
}

export const DownloadCSVButton = ({ event }: DownloadCSVButtonProps) => {
  const onDownloadCSV = useDownloadCSV({ event });

  return (
    <Button
      onClick={onDownloadCSV}
      variant="link"
      className="!text-dark !flex !items-center !px-0 !text-sm !font-normal"
    >
      <span className="mr-2">{t("events.edit_modal.people.download_csv")}</span>
      <Icon type="download" size={20} />
    </Button>
  );
};
